<template>
  <div
    class="svg-button"
    :class="{
      'disabled': disabled
    }"
    @mouseover="(!hovered ? hover(true) : null)"
    @mouseleave="hover(false)"
    @click="clicked"
  >
    <div
      class="center-block"
      :title="toolTipText"
    >
      <p4a-icon
        slot="face"
        class="svg-image"
        v-if="icon"
        :style="{
          'width': size.width,
          'height': size.height,
          'transform': 'rotate(' + rotation + 'turn)'
        }"
        :icon="iconData"
        :color="svgColor"
      />

      <label
        class="button-label"
        v-if="text"
        :style="{ 'color': textColor }"
        v-text="text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SvgButton',
  data () {
    return {
      hovered: false,
      defaultIcon: 'closeModal-icon'
    }
  },
  components: {
  },
  props: {
    icon: {
      default: '',
      type: String
    },
    text: {
      default: null,
      type: String
    },
    toolTipText: {
      default: null,
      type: String
    },
    strokeColor: {
      default: null,
      type: String
    },
    size: {
      default: function () {
        return {
          'height': '20px',
          'width': '20px'
        }
      },
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    },
    forcedHover: {
      default: false,
      type: Boolean
    },
    rotation: {
      default: 0.0,
      type: Number
    },
    defaultColor: {
      default: '#58585b',
      type: String
    },
    disabledColor: {
      default: '#EEEEEE',
      type: String
    },
    hoverColor: {
      default: '#F26722',
      type: String
    },
    defaultTextColor: {
      default: '#58585b',
      type: String
    },
    disabledTextColor: {
      default: '#58585b',
      type: String
    },
    hoverTextColor: {
      default: '#58585b',
      type: String
    }
  },
  methods: {
    hover (value) {
      let self = this
      self.hovered = self.forcedHover ? self.forcedHover : value
    },
    clicked () {
      let self = this
      if (!self.disabled) {
        self.$emit('clicked')
      }
    }
  },
  computed: {
    svgColor () {
      let self = this
      return self.disabled ? self.disabledColor : (self.hovered ? self.hoverColor : self.defaultColor)
    },
    textColor () {
      let self = this
      return self.disabled ? self.disabledTextColor : (self.hovered ? self.hoverTextColor : self.defaultTextColor)
    },
    iconData () {
      let self = this
      return (self.icon ? self.icon : self.defaultIcon)
    }
  },
  watch: {
    forcedHover () {
      let self = this
      self.hover(self.forcedHover)
    }
  }
}
</script>

<style lang="scss" scoped>

.svg-button {
  font-size: 0;
  cursor: pointer;

  .center-block {
    margin: auto;
    display: table;
    align-content: center;

    .svg-image {
      display: table-cell;
      vertical-align: middle;
    }

    .button-label {
      display: table-cell;
      vertical-align: middle;
      cursor: pointer;

      font-size: 14px;
      padding-left: 9px;
      font-weight: 400;
      height: 100%;
      line-height: 14px;
      transition-duration: 0.2s;

      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ButtonTemplates/SvgButton.vue